import { Controller } from '@hotwired/stimulus';

// A section saved in place makes the nudge stale, so it goes without a page load. States that
// only a new CV can clear opt out, since the save left the profile outdated. Dismissal itself
// belongs to dismissible-banner, which this sits beside.
export default class extends Controller {
  static values = { hideOnUpdate: Boolean };

  connect() {
    this.hideAfterUpdate = () => {
      if (this.hideOnUpdateValue) this.element.remove();
    };
    window.addEventListener('tp:profile-updated', this.hideAfterUpdate);
  }

  disconnect() {
    window.removeEventListener('tp:profile-updated', this.hideAfterUpdate);
  }
}
